export const FETCH_USER_INFORMATION_REQUEST = 'FETCH_USER_INFORMATION_REQUEST';
export const FETCH_USER_INFORMATION_SUCCESS = 'FETCH_USER_INFORMATION_SUCCESS';
export const FETCH_USER_INFORMATION_FAILURE = 'FETCH_USER_INFORMATION_FAILURE';
